document.addEventListener('DOMContentLoaded', function () {
	const languageSwitcher = document.querySelector('.wpml-ls-legacy-dropdown-click')
	if (!languageSwitcher) return

	const toggle = languageSwitcher.querySelector('.js-wpml-ls-item-toggle')
	const submenu = languageSwitcher.querySelector('.wpml-ls-sub-menu')
	if (!toggle || !submenu) return

	// ✅ MUSI być class="wpml-arrow", inaczej nie zadziała obrót
	const arrowSvg = `
    <svg class="wpml-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
      <path d="M4.00021 6.00032L8.00041 10.0005L12.0006 6.00032" stroke="currentColor" stroke-width="1.3334" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `

	const existingArrow = toggle.querySelector('.wpml-arrow')
	if (existingArrow) existingArrow.remove()
	toggle.insertAdjacentHTML('beforeend', arrowSvg)

	function toggleSubmenu(show) {
		const arrow = toggle.querySelector('.wpml-arrow')

		if (show) {
			submenu.style.visibility = 'visible'
			submenu.style.display = 'block'
			toggle.setAttribute('aria-expanded', 'true')
			if (arrow) arrow.classList.add('wpml-arrow-open')

			submenu.querySelectorAll('li').forEach((item) => {
				item.style.display = 'block'
				item.style.visibility = 'visible'
			})
		} else {
			submenu.style.visibility = 'hidden'
			submenu.style.display = 'none'
			toggle.setAttribute('aria-expanded', 'false')
			if (arrow) arrow.classList.remove('wpml-arrow-open')
		}
	}

	toggle.addEventListener('click', function (e) {
		e.preventDefault()
		e.stopPropagation()
		const isExpanded = toggle.getAttribute('aria-expanded') === 'true'
		toggleSubmenu(!isExpanded)
	})

	toggle.addEventListener('keydown', function (e) {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault()
			const isExpanded = toggle.getAttribute('aria-expanded') === 'true'
			toggleSubmenu(!isExpanded)
		}
	})

	document.addEventListener('click', function (e) {
		if (!languageSwitcher.contains(e.target)) toggleSubmenu(false)
	})

	submenu.querySelectorAll('a').forEach((link) => {
		link.addEventListener('click', function () {
			toggleSubmenu(false)
		})
	})

	const observer = new MutationObserver(function (mutations) {
		mutations.forEach(function (mutation) {
			if (mutation.attributeName !== 'style') return
			if (toggle.getAttribute('aria-expanded') !== 'true') return

			const target = mutation.target

			if (target === submenu && target.style.visibility === 'hidden') {
				target.style.visibility = 'visible'
			}

			if (target.tagName === 'LI' && target.closest('.wpml-ls-sub-menu')) {
				if (target.style.display === 'none') target.style.display = 'block'
				if (target.style.visibility === 'hidden') target.style.visibility = 'visible'
			}
		})
	})

	observer.observe(submenu, {
		attributes: true,
		attributeFilter: ['style'],
		subtree: true,
	})

	toggleSubmenu(false)

	languageSwitcher.addEventListener('mouseenter', function () {
		toggleSubmenu(true)
	})

	languageSwitcher.addEventListener('mouseleave', function () {
		toggleSubmenu(false)
	})
})